/** Texto de ayuda — pantalla «Tipos de Informe y Recomendaciones» (HubInformes) */

export const SECCIONES_AYUDA_MENU_INFORMES = [
  {
    titulo: "¿Qué es esta pantalla?",
    parrafos: [
      "Es el menú principal de Reportes Informes del paciente. Desde aquí puede crear, editar e imprimir los documentos clínicos de la terapia que tiene asignada con usted como especialista logueado.",
      "Solo verá informes de estudios activos, asignados a su cédula y de la especialidad seleccionada (por ejemplo, Terapia Ocupacional).",
    ],
  },
  {
    titulo: "Paciente",
    parrafos: [
      "Muestra el nombre del paciente con el que está trabajando en este momento.",
      "Si lo consultó antes en Consulta terapias x días o abrió Informes desde el Maestro de Citas, aparece ese paciente.",
      "Si lo eligió desde «Pacientes sin Evaluación Inicial», el nombre cambia al seleccionado en la lista y se mantiene aunque use «Menú principal» dentro del flujo de informes.",
    ],
  },
  {
    titulo: "Tipo de estudio",
    parrafos: [
      "Solo aparece si usted tiene más de una especialidad registrada (por ejemplo, Terapia Ocupacional e Integración Sensorial).",
      "Debe elegir la rama que corresponda al estudio del paciente. Si el paciente tiene terapia Ocupacional pero la lista muestra otra rama, las opciones 1, 2 y 3 pueden quedar bloqueadas.",
      "En Maestro de médicos, las especialidades deben ir separadas por coma (ej.: TERAPEUTA OCUPACIONAL, SENSORIAL), no en una sola línea con guiones.",
    ],
  },
  {
    titulo: "Recuadro verde de resumen",
    parrafos: [
      "Resume el estudio activo del paciente con usted:",
    ],
    lista: [
      "Días: días de la semana con cita (ej. Miércoles, Sábado). Si el paciente asiste varios días, el sistema puede agruparlos en un solo estudio.",
      "Inicio: fecha de inicio del estudio.",
      "Citas pagadas: X de 4 — cantidad de citas con recibo pagado. El número 4 es el mínimo requerido para habilitar el Informe de Evaluación y Plan (no es un tope máximo).",
    ],
    subsecciones: [
      {
        titulo: "Terapias Pagadas",
        texto:
          "Despliega la lista de fechas y números de recibo de las citas pagadas del estudio.",
      },
      {
        titulo: "Reportes Diarios",
        texto:
          "Abre un cuadro con los reportes de cita registrados (fecha, mensaje y adjunto si existe) para ese estudio.",
      },
    ],
  },
  {
    titulo: "Opciones del menú",
    lista: [
      "1. Evaluación Inicial — Primer documento del proceso. Habilitada cuando hay un estudio activo de la especialidad seleccionada con usted. Si ya existe su evaluación inicial para ese estudio, solo podrá editarla.",
      "2. Informe de Evaluación y Plan — Requiere Evaluación Inicial creada y al menos 4 citas pagadas en el estudio (suma de todos los días). Si está en gris, el texto indica qué falta. Incluye Ayuda Informe con IA solo al crear el informe por primera vez.",
      "3. Informe de avance — Requiere el Informe de Evaluación y Plan. Puede crear hasta 4 informes de avance. El menú muestra (N de 4). Para cada avance nuevo se requieren citas pagadas después de la fecha del Plan o del avance anterior: 16 citas si asiste 1 día por semana, 32 citas si asiste 2 días por semana.",
      "4. Recomendaciones para el hogar (próximamente) — Opción reservada, aún no disponible.",
      "5. Recomendaciones para el colegio (próximamente) — Opción reservada, aún no disponible.",
      "6. Informe de alta (próximamente) — Opción reservada, aún no disponible.",
    ],
  },
  {
    titulo: "Botones inferiores",
    parrafos: [
      "Pacientes sin Evaluación Inicial: lista sus pacientes con terapia activa en la especialidad seleccionada que aún no tienen Evaluación Inicial. Pulse una fila para cargar ese paciente en este mismo menú.",
      "Pacientes sin Informe Evaluación y Plan: misma idea para pacientes que ya tienen Evaluación Inicial pero no el Informe de Evaluación y Plan (cuando cumplen las reglas de citas pagadas).",
    ],
  },
  {
    titulo: "Mensajes frecuentes",
    lista: [
      "«La especialidad del paciente no coincide con la del especialista»: no hay terapias activas suyas para ese paciente o la rama del desplegable no coincide.",
      "«El paciente no tiene estudios activos de [rama] con usted»: tiene otra rama seleccionada o el estudio está asignado a otro especialista.",
      "Opción 1 en gris sin mensaje: verifique que inició sesión con su usuario, que su ficha médica tiene la especialidad correcta y que el paciente está asignado a usted.",
    ],
  },
  {
    titulo: "Flujo recomendado",
    parrafos: [
      "Evaluación Inicial → (4 citas pagadas) → Informe de Evaluación y Plan → (citas según días por semana) → Informe de avance (hasta 4) → en el futuro: recomendaciones y alta.",
    ],
  },
  {
    titulo: "Impresión PDF",
    parrafos: [
      "Desde cada formulario puede imprimir el PDF si tiene su firma digital cargada en el sistema. Sin firma, no se generará el documento.",
    ],
  },
];
